var SENTRY_RELEASE;SENTRY_RELEASE={name: "Reactiive", version: "1.0.0"};